const theme = {
  token: {
    colorWhite: '#fff',
    colorBlack: '#000',
    colorPrimary: '#39d3c6',
    colorLink: '#39d3c6',
    colorHighlight: '#f5222d',
    colorSuccess: '#52c41a',
    colorInfo: '#0ca2d0',
    colorError: '#f5222d',
    colorWarning: '#faad14',
    colorText: '#1d374e',
    colorTextHeading: '#1d374e',
    colorTextSecondary: '#1d374ebb',
    colorTextDisabled: '#C7C7C8',
    colorBorderSplit: '#1d374e',
    colorAccent: '#f5985e',
    colorBorder: '#d9d9d9',

    borderRadius: 16,

    boxShadow:
      '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',

    fontFamily: 'Arial, Helvetica, sans-serif',
    fontFamilyCode: 'Consolas, monaco, monospace',

    // Custom variables
    // They are not used diirectly by ant design, but available as css variables or in styled components
    colorTestCustom: '#4fbd67', // Ant design will make it available in css as var(--ant-color-text-custom);

    colorSecondary: '#f5985e',
    colorLightSecondary: '#fce0cf',
    lightBackground: '#f2f1ed',
    darkBackground: '#1d374e',
    darkGrey: '#8e8b7e',
    midGrey: '#dbd9d1',
    lightGrey: '#f8f8f8',

    contentSpaceV: 12,
    contentSpaceH: 20,
    marginV: '1.2rem',
    marginH: '0.8rem',
  },
  components: {
    Badge: {
      colorError: '#f5985e',
    },
    Collapse: {
      contentPadding: 0,
      colorTextHeading: '#1d374e',
    },
    Popover: {
      borderRadiusLG: 8,
    },
    Select: {
      colorFillSecondary: '#c4f2ee',
    },
    Tag: {
      defaultBg: '#c4f2ee',
    },
    Table: {
      colorTextHeading: '#1d374e',
      headerSortActiveBg: '#f2f1ed',
      headerSortHoverBg: '#f2f1ed',
      rowHoverBg: '#e9fbf6',
    },
    Tooltip: {
      colorBgSpotlight: '#ffffff',
      colorText: '#1d374e',
      colorTextLightSolid: '#1d374e',
      borderRadius: 8,
    },
    DatePicker: {
      colorTextHeading: '#1d374e',
    },
    Notification: {
      paddingMD: 10,
      paddingLG: 10,
      paddingContentHorizontalLG: 10,
      marginSM: 10,
      marginLG: 10,
      fontSize: 14,
      fontSizeLG: 14,
      borderRadiusLG: 8,
    },
  },
};

export default theme;
